import React, { Fragment } from 'react';

const Home = () => {

	return(
		<Fragment>
			<h1 className='text-center m-5'>Welcome Gamer</h1>
		</Fragment>
		)

}

export default Home;